import { userEventsApi } from "@api/instances";
import { USEREVENTS_BASE_URL } from "@config";
import { getEventContext } from "@utils/eventContext";
import rollbar from "@utils/rollbar";

const postEvent = async (path: string, body: Record<string, unknown>): Promise<void> => {
  if (!USEREVENTS_BASE_URL) return;
  try {
    await userEventsApi.post(path, body, {
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    const err = error instanceof Error ? error : new Error(String(error), { cause: error });
    rollbar.warning("userevents request failed", err, { endpoint: path });
  }
};

export const trackEvent = (event: string, properties: Record<string, unknown>): Promise<void> =>
  postEvent("/event/tr", { event, properties, context: getEventContext() });
